import React from 'react';
import ICONS from '../../../assets/icons'

export const period = [
  {
    periodCode: 'today',
    text: 'Today',
  },
  {
    periodCode: 'thisWeek',
    text: 'Current Week',
  },
  {
    periodCode: 'thisMonth',
    text: 'Current Month',
  },
  {
    periodCode: 'last3Months',
    text: 'Last 3 Months',
  },
  {
    periodCode: 'last6Months',
    text: 'Last 6 Months',
  },
];

export const SLA = [
  {
    text: 'Upcoming',
    value: 'upcoming',
    icon: <ICONS.arrowUpRight />,
  },
  {
    text: 'Upcoming today',
    value: 'upcomingToday',
    icon: <ICONS.disc />,
  },
  {
    text: 'Urgently upcoming',
    value: 'urgentlyUpcoming',
    icon: <ICONS.zap/>,
  },
  {
    text: 'Onsite done on time',
    value: 'onsiteDoneOnTime',
    icon: <ICONS.check/>,
  },
  {
    text: 'Onsite missed deadline',
    value: 'onsiteMissedDeadline',
    icon: <ICONS.x/>,
  },
  {
    text: 'Completion done on time',
    value: 'completionDoneOnTime',
    icon: <ICONS.checkCircle />,
  },
  {
    text: 'Completion missed deadline',
    value: 'completionMissedDeadline',
    icon: <ICONS.xCircle />,
  },
];

export const status = [
  {
    text: 'New',
    value: 'new',
    icon: <ICONS.star/>,
  },
  {
    text: 'Allocated',
    value: 'allocated',
    icon: <ICONS.user />,
  },
  {
    text: 'In Progress',
    value: 'inProgress',
    icon: <ICONS.loader/>
  },
  {
    text: 'On Hold',
    value: 'onHold',
    icon: <ICONS.pauseCircle/>
  },
  {
    text: 'Work Completed',
    value: 'workCompleted',
    icon: <ICONS.check/>
  },
  {
    text: 'Cancelled',
    value: 'cancelled',
    icon: <ICONS.xCircle />,
  },
  {
    text: 'Finished',
    value: 'finished',
    icon: <ICONS.checkCircle />
  },
];
